import { initialPurchasePlan } from "pages/purchase-plans/constants/defaultValues"
import { mapPricingCalculator, mapPricingExpression } from "pages/purchase-plans/mappers/mapPricingVariables"
import { setPurchasePlanIdentifiers } from "reducers/purchasePlan/purchase-plan-actions"
import { useAppDispatch } from "reducers/store"

import { useCallback, useMemo, useState } from "react"

const usePurchasePlanTable = () => {
  const [rowData, setRowData] = useState<App.PurchasePlan>(initialPurchasePlan)

  const appDispatch = useAppDispatch()

  const handleOnClickRow = useCallback((item) => {
    appDispatch(
      setPurchasePlanIdentifiers({
        productPrefixUrl: item.product.prefixUrl,
        productId: item.product._id,
        purchasePlanId: item._id
      })
    )

    setRowData((prevState) => ({
      ...prevState,
      ...item,
      benefits: item.benefits,
      product: item.product.prefixUrl
    }))
  }, [])

  const rowPricingCalculator = useMemo(() => {
    return {
      mathExp: rowData.pricingCalculator?.strExpression,
      list: rowData.pricingCalculator?.scope.map(mapPricingCalculator)
    }
  }, [rowData.pricingCalculator])

  const rowPricingExpression = useMemo(() => {
    return {
      mathExp: rowData.pricingExpression?.strExpression,
      list: rowData.pricingExpression?.scope.map(mapPricingExpression)
    }
  }, [rowData.pricingExpression])

  return {
    rowData,
    rowPricingCalculator,
    rowPricingExpression,
    handleOnClickRow
  }
}

export default usePurchasePlanTable
